import React, { useState } from "react";
import InputSearch from "../../../AddOSP/Component/Search/InputSearch";

const GeoDetails = () => {
  const [showModal, setShowModal] = useState(false);

  const handleViewVariants = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="p-4 bg-white rounded-md border border-gray-300 w-full relative">
      {/* Header */}
      <div className="flex justify-between pb-3 border-b items-center mb-4">
        <h2 className="text-base font-semibold text-[#333333]">Geo Details</h2>
        <button
          onClick={handleViewVariants}
          className="flex items-center gap-1 bg-[#0099E5] hover:bg-[#007FCC] text-white text-sm px-3 py-1.5 rounded"
        >
          <span className="bg-white text-[#0099E5] rounded-full w-5 h-5 flex items-center justify-center text-xs font-semibold">
            2
          </span>
          View Variants
        </button>
      </div>

      {/* Content */}
      <table className="w-full text-sm text-[#333333]">
        <tbody>
          <tr>
            <td className="py-2 w-1/4">Country :</td>
            <td className="py-2 w-1/4 font-semibold">India</td>
            <td className="py-2 w-1/4">State :</td>
            <td className="py-2 w-1/4 font-semibold">Tamil Nadu</td>
          </tr>
          <tr>
            <td className="py-2">City / District :</td>
            <td className="py-2 font-semibold">Chennai</td>
            <td className="py-2">Locality :</td>
            <td className="py-2 font-semibold">6383516799</td>
          </tr>
          <tr>
            <td className="py-2">Street :</td>
            <td className="py-2 font-semibold">Broadway</td>
            <td className="py-2">Pin Code :</td>
            <td className="py-2 font-semibold">600001</td>
          </tr>
        </tbody>
      </table>

      {/* Modal/Popup */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-1/2 overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Geo Details Variants</h3>
              <InputSearch />
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <hr />
            <h3 className="text-lg font-semibold underline underline-offset-4">
              Geo Details 1:
            </h3>
            <table className="w-full text-sm text-[#333333]">
              <tbody>
                <tr>
                  <td className="py-2 w-1/4">Country :</td>
                  <td className="py-2 w-1/4 font-semibold">India</td>
                  <td className="py-2 w-1/4">State :</td>
                  <td className="py-2 w-1/4 font-semibold">Tamil Nadu</td>
                </tr>
                <tr>
                  <td className="py-2">City / District :</td>
                  <td className="py-2 font-semibold">Chennai</td>
                  <td className="py-2">Locality :</td>
                  <td className="py-2 font-semibold">6383516799</td>
                </tr>
                <tr>
                  <td className="py-2">Street :</td>
                  <td className="py-2 font-semibold">Broadway</td>
                  <td className="py-2">Pin Code :</td>
                  <td className="py-2 font-semibold">600001</td>
                </tr>
              </tbody>
            </table>
            <h3 className="text-lg font-semibold underline underline-offset-4">
              Geo Details 2:
            </h3>
            <table className="w-full text-sm text-[#333333]">
              <tbody>
                <tr>
                  <td className="py-2 w-1/4">Country :</td>
                  <td className="py-2 w-1/4 font-semibold">India</td>
                  <td className="py-2 w-1/4">State :</td>
                  <td className="py-2 w-1/4 font-semibold">Tamil Nadu</td>
                </tr>
                <tr>
                  <td className="py-2">City / District :</td>
                  <td className="py-2 font-semibold">Chennai</td>
                  <td className="py-2">Locality :</td>
                  <td className="py-2 font-semibold">6383516799</td>
                </tr>
                <tr>
                  <td className="py-2">Street :</td>
                  <td className="py-2 font-semibold">Broadway</td>
                  <td className="py-2">Pin Code :</td>
                  <td className="py-2 font-semibold">600001</td>
                </tr>
              </tbody>
            </table>
            <div className="mt-6 flex justify-end">
              <button
                onClick={closeModal}
                className="bg-[#0099E5] hover:bg-[#007FCC] text-white px-4 py-2 rounded text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GeoDetails;
